import { useField } from 'formik';
import { motion } from 'framer-motion';

interface IAcademiaColorPicker {
  placeholder: string;
  label: string;
  name: string;
  isRequired?: boolean;
}

const AcademiaColorPicker = ({
  name,
  label,
  placeholder,
  isRequired,
}: IAcademiaColorPicker) => {
  // integration of formik hooks here
  const [field, meta] = useField({ name });

  // rendering custom color picker input field component here
  return (
    <div>
      <label
        htmlFor={`input-${name}`}
        title={isRequired ? 'This field is required' : ''}
        className='block mb-1 text-legal-dark-blue font-medium text-base'
      >
        {label} {isRequired && <span className='text-base-red'>*</span>}
      </label>

      <div className='flex items-center gap-3'>
        <div className='relative flex-1'>
          <motion.input
            initial={{ x: 0 }}
            animate={
              meta.touched && meta.error
                ? {
                    x: [0, -100, 0, 100, 0],
                    transition: {
                      duration: 0.1,
                      repeat: 2,
                    },
                  }
                : { x: 0 }
            }
            type='text'
            className={`border-2 focus:ring-0 rounded-md p-3 w-full text-legal-dark-blue font-medium duration-300 text-base ${
              meta.touched && meta.error
                ? 'border-base-red'
                : 'border-legal-dark-blue'
            }`}
            value={field.value || '#000000'}
            placeholder={placeholder}
            readOnly
          />

          <div
            style={{ backgroundColor: field.value || '#000000' }}
            className='absolute top-1/2 right-3 -translate-y-1/2 h-6 w-10 rounded-md'
          ></div>
        </div>

        <label
          htmlFor={`${name}_field`}
          className='inline-block bg-legal-dark-blue text-base-white rounded-md px-5 py-3 hover:opacity-70 active:scale-95 duration-300 cursor-pointer'
        >
          Pick Color
          <input
            type='color'
            id={`${name}_field`}
            className='size-0'
            value={field.value || '#000000'}
            onChange={field.onChange}
            onBlur={field.onBlur}
            name={field.name}
          />
        </label>
      </div>
    </div>
  );
};

export default AcademiaColorPicker;
